import { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { signup } from '../api/api';
import { Lang } from '../api/lang';
import { getInitialLang, getStoredLang, setStoredLang } from '../api/langStorage';
import { getStoredRes } from '../api/resStorage';

const Signup = () => {
    const [lang, setLang] = useState<string>(() => getStoredLang());
    const [resolution, setResolution] = useState<string>(() => getStoredRes());
    const [isPortrait, setIsPortrait] = useState(false);
    const [bgopacity, setBgopacity] = useState<number>(1);
    const [titleopacity, setTitleopacity] = useState<number>(0);
    const [dialogopacity, setDialogopacity] = useState<number>(0);

    const [email,setEmail] = useState("");
    const [username,setUsername] = useState("");
    const [password,setPassword] = useState("");
    const [repassword,setRepassword] = useState("");
    const [loading, setLoading] = useState(false);
    const [isSuccess, setIsSuccess] = useState(false);
    const [error, setError] = useState('');
    const [rotate,setRotate]=useState<number>(0);
    const history = useHistory();

    const handleSubmit = () => {
        setLoading(true);
        setError("");
        //validate 
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!email || !emailRegex.test(email)) {
            setLoading(false);
            setError("missing_email");
            return;
        }
        //validate email format
        if (!username) {
            setLoading(false);
            setError("missing_username");
            return;
        }
        if (!password) {
            setLoading(false);
            setError("missing_password");
            return;
        }
        if (!repassword) {
            setLoading(false);
            setError("missing_repassword");
            return;
        }
        if (password!==repassword) {
            setLoading(false);
            setError("password_not_match");
            return;
        }
        if (password.length<6) {
            setLoading(false);
            setError("password_must_be_at_least_6_characters");
            return;
        }   
        signup(email,password,repassword,username,lang).then((res)=>{
            setLoading(false);
            setIsSuccess(true);
            setError("");
        }).catch((err)=>{
            setLoading(false);
            if (err.response!==undefined && err.response.status===400) {
                setError(err.response.data.error);
            } else {
                setError("network_error");
            }
        });     
    }

    const handleBack = () => {
        history.replace("/?lang="+lang+"&resolution="+resolution);
    }

        const handleLangChange = (value: string) => {
            setStoredLang(value);
            setLang(value);
        }

    useEffect(() => {
        document.title=Lang.get(lang,"lethal_blade_title");
    }, [lang]);

    const fadeInTitle=()=> {
      let opacity = 0;
      let bgopacity = 1;
      let dialogopacity = 0;
      const interval = setInterval(() => {
        opacity += 0.05; // เพิ่มทีละ 0.05
        setTitleopacity(opacity);
        bgopacity -= 0.03; // ลดทีละ 0.01
        setBgopacity(bgopacity);
        dialogopacity += 0.05; // เพิ่มทีละ 0.05
        setDialogopacity(dialogopacity);
        if (opacity >= 1) {
          clearInterval(interval); // หยุดเมื่อ opacity = 1
        }
      }, 130); 
    }
  
    useEffect(() => {
        document.body.style.backgroundColor = "black";
        fadeInTitle();
        const mediaQuery = window.matchMedia("(orientation: portrait)");
        const handleOrientationChange = (e:any) => {
        setIsPortrait(e.matches);
        };
        setIsPortrait(mediaQuery.matches);
        mediaQuery.addEventListener("change", handleOrientationChange);

        setLang(getInitialLang(window.location.search));
        //ทำ animation หมุนรอ ช้าๆ
        const interval = setInterval(() => {
            setRotate((prevRotate) => (prevRotate + 1) % 360);
        }, 100);
        return () => {
        clearInterval(interval);
        mediaQuery.removeEventListener("change", handleOrientationChange);
        };
    }, []);

    return (<>
        <div className="c" style={{width:"100%",paddingRight:"10px",paddingTop:"10px",overflowX: "hidden",position: "absolute",zIndex: 9999}}>
            <table><tbody><tr>
            <td width="80%"></td>
            <td width="220px" style={{textAlign: "right",whiteSpace: "nowrap"}}>
                {Lang.get(lang,"bandwidth")}&nbsp;&nbsp;
            </td>
            <td width="80px">
            <select value={resolution} className="form-select form-select-sm form-control-sm" onChange={e=>{setResolution(e.currentTarget.value)}} style={{width:"70px"}}>
                <option value="low" >{Lang.get(lang,"low")}</option>
                <option value="high" >{Lang.get(lang,"high")}</option>
            </select>
            </td>
            <td width="80px">
            <select value={lang} className="form-select form-select-sm form-control-sm" onChange={e=>{handleLangChange(e.currentTarget.value)}} style={{width:"70px"}}>
                <option value="th">ไทย</option>
                <option value="en">Eng</option>
            </select>
            </td>
            </tr></tbody></table>
        </div>
        <div className="c" style={{top:60,left: "50%",transform: "translate(-50%, 0)",marginLeft:"10px",width: "800px",position: "absolute",zIndex: 9999,display: "block",textAlign: "center",justifyContent: "center", opacity: dialogopacity}}>
            <img src={"lethalblade/assets/"+resolution+"/header.png"} alt="header" style={{width:"300px",height:"80px", transform: "scaleY(-1)"}}/><br/>            
            { loading &&
            <img src={"lethalblade/assets/"+resolution+"/loading.png"} alt="loading" style={{width:"50px",height:"50px",transform: "rotateZ("+rotate+"deg)",zIndex: 9999}}/>
            }
            { (isSuccess) &&
                <><span>{ Lang.get(lang,"signup_success")}</span><br/>
                <br/>
                <div className="buttonup"  style={{cursor: "pointer",position:"relative"}} onClick={handleBack}>
                    <img src={"lethalblade/assets/"+resolution+"/buttonn.png"} alt="click"/>
                    <div style={{position: "absolute",marginTop: "-5px",marginLeft:"-2px",top:"50%",left: "50%",transform: "translate(-50%, -50%)"}}>
                    { Lang.get(lang,"back")}
                    </div>
                </div></>
            }
            { !isSuccess &&
            <>
            <span className="header">{ Lang.get(lang,"signup")}</span><br/>
            <div style={{height:"10px"}}></div>
            <input className="inputnoborder" type="text"  style={{width: "200px",height:"50px",backgroundColor: "rgba(0, 0, 0, 0.5)",borderRadius: "5px",borderColor:"#4ca0ab", color: "white" }} maxLength={200} value={email} onChange={e => setEmail(e.target.value)} placeholder={Lang.get(lang,"email")} disabled={loading}/><br/>
            <div style={{height:"10px"}}></div>
            <input className="inputnoborder" type="text"  style={{width: "200px",height:"50px",backgroundColor: "rgba(0, 0, 0, 0.5)",borderRadius: "5px",borderColor:"#4ca0ab", color: "white" }} maxLength={200} value={username} onChange={e => setUsername(e.target.value)} placeholder={Lang.get(lang,"username")} disabled={loading}/><br/>
            <div style={{height:"10px"}}></div>
            <input className="inputnoborder" type="password" style={{width: "200px",height:"50px",backgroundColor: "rgba(0, 0, 0, 0.5)",borderRadius: "5px",borderColor:"#4ca0ab", color: "white" }} maxLength={200} value={password} onChange={e => setPassword(e.target.value)} placeholder={Lang.get(lang,"password")} disabled={loading}/><br/>
            <div style={{height:"10px"}}></div>
            <input className="inputnoborder" type="password" style={{width: "200px",height:"50px",backgroundColor: "rgba(0, 0, 0, 0.5)",borderRadius: "5px",borderColor:"#4ca0ab", color: "white" }} maxLength={200} value={repassword} onChange={e => setRepassword(e.target.value)} placeholder={Lang.get(lang,"repassword")} disabled={loading}/><br/>
            <div style={{height:"10px"}}></div>
            { error!=="" &&
                <><span style={{color:"red"}}>{ Lang.get(lang, error)}</span><br/></>
            }
            <div className="buttonup"  style={{cursor: "pointer",position:"relative"}} onClick={handleSubmit}>
                <img src={"lethalblade/assets/"+resolution+"/buttonn.png"} alt="click"/>
                <div style={{position: "absolute",marginTop: "-5px",marginLeft:"-2px",top:"50%",left: "50%",transform: "translate(-50%, -50%)"}}>
                { Lang.get(lang,"ok_title")}
                </div>
            </div>
            <div className="buttonup"  style={{cursor: "pointer",position:"relative"}} onClick={handleBack}>
                <img src={"lethalblade/assets/"+resolution+"/buttonn.png"} alt="click"/>
                <div style={{position: "absolute",marginTop: "-5px",marginLeft:"-2px",top:"50%",left: "50%",transform: "translate(-50%, -50%)"}}>
                { Lang.get(lang,"cancel_title")}
                </div>
            </div>
            </>}
            <img src={"lethalblade/assets/"+resolution+"/header.png"} alt="header" style={{width:"300px",height:"80px",marginTop:"-20px"}}/>
        </div>
        <div className="bg" style={{justifyContent: "center", textAlign: "center",opacity: bgopacity, backgroundImage: "url(lethalblade/assets/"+resolution+"/bg2.jpg)"}}>
        &nbsp;
        </div>
        <div className="c" style={{position: "absolute",left: "50%",transform: "translate(-50%, 0)",marginLeft:"0px",bottom:"0px",zIndex: 999,whiteSpace: "nowrap"}}>
        { Lang.get(lang,"copyright_title")} { Lang.get(lang,"all_right_reserve_title")}
        </div>
        </>);
}


export default Signup;

